import React from "react";
import { useProductData } from "../../hooks/useProductData";
import CategoryShimmer from "../../Shimmer/CategoryShimmer";
import Products from "../ProductPage/Products";
import ProductCard from "../ProductPage/ProductCard";
import ProductDataSets from "../../../src/Janica.products.json";
const CategorywiseProducts = ({ category, title }) => {
  const { productData, loading } = useProductData();

  const JsonProducts = productData?.length ? productData : ProductDataSets;

  if (loading) return <CategoryShimmer />;
  if (!JsonProducts?.length) return <div>No products found</div>;
  const filteredProducts = JsonProducts?.filter((item) =>
    (item?.name).toLowerCase().includes(category.toLowerCase())
  );

  return (
    <div className="sm:w-[90%] w-full relative mx-auto overflow-hidden">
      <h2 className="sm:text-3xl text-xl text-white font-semibold">{title}</h2>
      <div className="grid 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 xs:grid-cols-2 grid-cols-1 place-items-center gap-5">
        {" "}
        {filteredProducts?.length ? (
          filteredProducts.slice(0, 5).map((item) => {
            return (
              <div key={item.id} className="">
                <ProductCard item={item} />
              </div>
            );
          })
        ) : (
          <p>404</p>
        )}
      </div>
    </div>
  );
};

export default CategorywiseProducts;
